import { CONVERSIONS_TABS } from './conversionTabs';

export const conversionTabItems = [
    {
        id: CONVERSIONS_TABS.EVENTS_ON_THIS_PAGE,
        caption: {
            id: 'codeless.events.on.this.page.tab',
            defaultMessage: 'Events On this page',
        },
    },
    {
        id: CONVERSIONS_TABS.ALL_YOUR_EVENTS,
        caption: {
            id: 'codeless.all.your.events.tab',
            defaultMessage: 'All Your events',
        },
    },
];
